import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { DEFAULT_MAX_SCROLL_ATTEMPTS, DEFAULT_SCROLL_DELAY, HEADER_OFFSET } from 'const';

type Options = {
  offset?: number;
  maxAttempts?: number;
  delay?: number;
  behavior?: ScrollBehavior;
};

const useScrollToHash = ({
  // Офсет хэдера
  offset = HEADER_OFFSET,
  maxAttempts = DEFAULT_MAX_SCROLL_ATTEMPTS,
  delay = DEFAULT_SCROLL_DELAY,
  behavior = 'smooth',
}: Options = {}) => {
  const location = useLocation();
  useEffect(() => {
    const hash = location.hash.slice(1);
    if (!hash) {
      return;
    }
    let attempts = 0;
    let timeoutId: number | null = null;
    let scrollTimeoutId: number | null = null;
    let prevY: number;

    const scroll = () => {
      const element = document.getElementById(hash);

      if (element) {
        const y = element.getBoundingClientRect().top + window.pageYOffset - offset;

        // Исправляет сдвиг при добавлении элементов в разметке по ходу загрузки
        if (prevY !== y) {
          prevY = y;
          scrollTimeoutId = window.setTimeout(scroll, delay);
        } else {
          window.scrollTo({ top: y, behavior });
        }
        return;
      }

      if (attempts < maxAttempts) {
        attempts++;
        timeoutId = window.setTimeout(scroll, delay);
      }
    };

    scroll();
    return () => {
      if (timeoutId) {
        window.clearTimeout(timeoutId);
      }

      if (scrollTimeoutId) {
        window.clearTimeout(scrollTimeoutId);
      }
    };
  }, [location.hash]);
};

export default useScrollToHash;
